/**
 * Whether the person arrived at the login page by signing out, rather than by opening the application: the
 * difference between "sign in to continue" and "you have been disconnected".
 *
 * In sessionStorage, beside the tokens themselves: per tab, and gone when the browser closes.
 */
const KEY = 'qrDynamic.signedOut';

export function markSignedOut(): void {
  try {
    sessionStorage.setItem(KEY, 'true');
  } catch {
    // Private browsing with storage denied: the sign-out still drops the tokens. Failing here would leave
    // somebody signed in instead.
  }
}

export function clearSignedOut(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
  }
}

export function wasSignedOut(): boolean {
  try {
    return sessionStorage.getItem(KEY) === 'true';
  } catch {
    return false;
  }
}
